import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/Login.css";

function Login() {
  const mustRedirect = useSelector((state) => state.shoppingCart.mustRedirect);
  const [email, setEmail] = useState("customer@customer.com");
  const [password, setPassword] = useState("CUSTOMER123");
  const [warning, setWarning] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    if (email === "" || password === "") {
      setWarning("Fill in both e-mail and password fields to log in.");
    } else {
      try {
        const response = await axios({
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/customers/tokens`,
          data: { email, password },
        });
        console.log(response.data);
        dispatch({ type: "LOGIN", payload: response.data.customer });
        dispatch({ type: "MODIFY_CART_CONTENT", payload: response.data.shoppingCartContent });
        navigate(mustRedirect ? "/checkout/1" : "/");
      } catch (err) {
        console.log(err);
        setWarning("Incorrect e-mail or password. Authentication failed.");
      }
    }
  };

  return (
    <div className="card border-0 shadow-lg rounded-3 initiate-session-panel">
      <div className="card-body p-5">
        <form onSubmit={handleSubmit}>
          <h1 className="fs-2">Login</h1>
          <p>Email: customer@customer.com | Password: CUSTOMER123</p>

          <div className="mb-3 mt-4">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              aria-describedby="email"
              value={email}
              placeholder="Email"
              onChange={(ev) => setEmail(ev.target.value)}
            />
          </div>

          <div className="mb-3 ">
            <label htmlFor="password" className="form-label">
              Password
            </label>

            <input
              type="password"
              className="form-control mb-1"
              id="password"
              aria-describedby="password"
              value={password}
              placeholder="Password"
              onChange={(ev) => setPassword(ev.target.value)}
            />
            <Link to="/forgot-password" className="text-white forgot-password">
              Forgot my password
            </Link>
          </div>

          <div className="d-flex align-items-center">
            <button className="btn submit-button mt-3">Login</button>
            {warning && (
              <p className="text-danger mb-0 ms-3 mt-3 fw-bold" style={{ fontSize: "0.8rem" }}>
                {warning}
              </p>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
